import { gql } from '@apollo/client'

export const cartFieldsFragment = gql`
  fragment CartFields on Cart {
    id
    stripePublicKey
    paymentIntentClientSecret
    total
    taxTotal
    subTotal
    shippingTotal
    shippingCountries {
      name
      code
      states {
        name
        code
      }
    }
    currency
    currencySymbol
    isPriced
    status
    hasPhysicalVariants
    errors
    skuIds
    customer {
      email
      first_name
      last_name
    }
    shippingAddress {
      address_1
      address_2
      city
      postal_code
      state
      country
    }
    billingAddress {
      address_1
      address_2
      city
      postal_code
      state
      country
    }
    bags {
      id
      merchant_name
      merchant {
        id
        supportUrl
        supportEmail
        brand {
          id
          title
          slug
        }
      }
      shipping_method {
        shipping_method_id
        type
        price
      }
      skus {
        id
        sku_id
        name
        thumbnail
        brand
        quantity
        line_price
        product_type
        productVariant {
          id
          name
          inStock
          product {
            id
            name
            shippingCountries {
              code
              states {
                code
                name
              }
            }
          }
        }
      }
    }
  }
`
